module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.getInternetExplorerVersion() == -1) ? [(_vm.config.zeigeOptionen) ? _c('optionen', {
    attrs: {
      "config": _vm.config
    }
  }) : _vm._e(), _vm._v(" "), (_vm.config.zeigeHinweise) ? [_c('div', {
    staticClass: "row"
  }, [_c('diagramm', {
    attrs: {
      "klasse": _vm.klasse
    }
  }), _vm._v(" "), (_vm.config.zeigeHinweise) ? _c('hinweise', {
    staticClass: "rechts",
    attrs: {
      "klasse": _vm.klasse
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.config.zeigeJavaCode) ? _c('java-code', {
    staticClass: "javaunten",
    attrs: {
      "klasse": _vm.klasse
    }
  }) : _vm._e()] : [_c('div', {
    staticClass: "row"
  }, [_c('diagramm', {
    attrs: {
      "klasse": _vm.klasse
    }
  }), _vm._v(" "), (_vm.config.zeigeJavaCode) ? _c('java-code', {
    staticClass: "rechts javarechts",
    attrs: {
      "klasse": _vm.klasse
    }
  }) : _vm._e()], 1)], _vm._v(" "), (_vm.config.zeigeRawData) ? _c('raw-data', {
    attrs: {
      "config": _vm.config
    }
  }) : _vm._e()] : [_vm._m(0)]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Funktioniert leider nicht mit dem Internet Explorer. Benutze bitte einen anderen Browser!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89f8b8f6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 27
// module chunks = 0